import { useQuery } from '@tanstack/react-query';
import { companySettingsService } from '../services/companySettingsService';

// Fallbacks for fields not yet filled in under Settings > Company —
// keeps receipts/invoices from rendering blank company info.
const DEFAULTS = {
  name: 'Reliable Landscaping and Design',
  address1: '1319 Avenida Alvarado',
  address2: 'Roseville, CA 95747',
  phone: '(916) 918-3990',
  email: 'admin@reliablelandscapesdesign.com',
  license: '#1101544',
};

/**
 * Shared company info sourced from the company_settings collection
 * (Settings > Company tab), shaped for receipts/invoices.
 */
export function useCompanyInfo() {
  const { data } = useQuery({
    queryKey: ['company-settings'],
    queryFn: () => companySettingsService.get(),
    staleTime: 5 * 60 * 1000,
  });

  const cs = data?.data || {};

  let address1 = DEFAULTS.address1;
  let address2 = DEFAULTS.address2;
  if (cs.address) {
    const lines = cs.address.split(/\r?\n/).map((s) => s.trim()).filter(Boolean);
    address1 = lines[0];
    address2 = lines.slice(1).join(', ');
  }

  return {
    name: cs.name || DEFAULTS.name,
    address1,
    address2,
    phone: cs.phone || DEFAULTS.phone,
    email: cs.email || DEFAULTS.email,
    license: cs.license || DEFAULTS.license,
  };
}
